export const continent2country = 
{
    ABB: ["IND","KOR","SGP","JPN","HKG"],
    EEE: ["BEL","CHE","DEU","DNK","ESP","FIN","FRA","GBR","IRL","ITA","NLD","NOR","PRT","SWE"],
    FFF: ["ZAF"],
    NNN: ["CAN","MEX","USA"],
    SRR: ["ARG","BRA","CHL"],
    UUU: ["AUS"]
}